var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('canvas',{ref:"elemento",staticStyle:{"max-height":"300px"},attrs:{"id":_vm.IdGrafico}})])
}
var staticRenderFns = []

export { render, staticRenderFns }